import React from 'react';
import { Link } from 'react-router-dom';
import { caseStudies } from '../../mockData';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { Button } from '../ui/button';

const ClientSuccessPreview = () => {
  // Feature 3 case studies
  const featuredCases = caseStudies.slice(0, 3);

  return (
    <section className="py-24 bg-white w-full min-h-screen bg-center bg-cover bg-no-repeat"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <TrendingUp className="w-4 h-4" />
            <span>Client Success Stories</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Delivering Measurable Results
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how we've helped enterprises across industries achieve digital transformation success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {featuredCases.map((caseStudy, index) => (
            <Link
              key={caseStudy.id}
              to={`/client-success/${caseStudy.id}`}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-indigo-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="text-sm font-semibold text-indigo-600 mb-3">{caseStudy.industry}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 line-clamp-2 group-hover:text-indigo-600 transition-colors duration-200">
                {caseStudy.title}
              </h3>
              <p className="text-gray-600 mb-6 line-clamp-3">{caseStudy.challenge}</p>
              <div className="space-y-2 mb-6">
                {caseStudy.results.slice(0, 2).map((result, idx) => (
                  <div key={idx} className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-sm text-gray-700">{result}</p>
                  </div>
                ))}
              </div>
              <div className="flex items-center text-indigo-600 font-medium text-sm group-hover:translate-x-2 transition-transform duration-200">
                <span>Read case study</span>
                <ArrowRight className="w-4 h-4 ml-2" />
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 rounded-xl shadow-lg hover:shadow-xl"
          >
            <Link to="/client-success" className="flex items-center space-x-2">
              <span>View All Success Stories</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ClientSuccessPreview;